"use client";

import { Link } from "@/i18n/navigation";
import { Button } from "@/components/ui/button";
import { useAnalytics } from "@/lib/analytics";

interface TrackedCtaButtonProps {
	location: string;
	href?: string;
	variant?: "default" | "outline";
	size?: "default" | "sm" | "lg";
	className?: string;
	children: React.ReactNode;
}

export function TrackedCtaButton({
	location,
	href = "/criar",
	variant = "default",
	size = "lg",
	className,
	children,
}: TrackedCtaButtonProps) {
	const { trackCtaClick } = useAnalytics();

	return (
		<Button
			asChild
			variant={variant}
			size={size}
			className={className}
			onClick={() => trackCtaClick(location)}
		>
			<Link href={href}>{children}</Link>
		</Button>
	);
}
